<template>
  <div class="soreness-area">
    <span @click.prevent.stop="openDialog = true" class="soreness-area-button">
      !
    </span>
    <v-dialog
      v-model="openDialog"
      content-class="player-modal soreness-area-modal"
      max-width="400px">
      <h3 class="modal-title">
        <span
          class="modal-close"
          @click.prevent.stop="openDialog = false"></span>
        Soreness Area
      </h3>
      <div class="player-modal-body soreness-area-modal-body">
        <img v-if="sorenessArea" :src="sorenessAreaImage" :alt="sorenessArea" />
        <p v-if="sorenessDescription">{{ sorenessDescription }}</p>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import constants from "@/constants.js"

export default {
  name: "SorenessArea",
  props: ["sorenessArea", "sorenessDescription"],
  data() {
    return {
      openDialog: false,
    }
  },

  computed: {
    sorenessAreaImage() {
      return constants.icons[this.sorenessArea.toLowerCase() + "Red"]
    },
    icons() {
      return constants.icons
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/_variables.sass'
.soreness-area
  display: inline-block

.soreness-area-button
  background-color: $peach
  border-radius: 100%
  color: $light-gray
  cursor: pointer
  display: inline-block
  font-size: 12px
  font-weight: bold
  text-align: center
  width: 18px
  height: 18px

.soreness-area-modal-body
  text-align: center

  img
    margin: 30px auto 10px

  p
    text-transform: capitalize
    text-align: center
    color: white
    font-size: 20px
    font-weight: bold
</style>
